import { useContext, useMemo } from "react";
import { ThemeProvider } from "styled-components";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import GlobalStyles from "./styles";
import AppProvider, { AppContext } from "./context";
import Home from "./screens/Public/Home";
import Products from "./screens/Public/Products";
import Farm from "./screens/Public/Farm";
import Process from "./screens/Public/Process";
import About from "./screens/Public/About";
import Contact from "./screens/Public/Contact";
import PrivacyPolicy from "./screens/Public/PrivacyPolicy";
import Disclaimers from "./screens/Public/Disclaimers";
import TermsAndConditions from "./screens/Public/TermsAndConditions";
import RefundPolicy from "./screens/Public/RefundPolicy";
import PageNotFound from "./screens/Public/PageNotFound";
import Register from "./screens/Authentication/Register";
import Login from "./screens/Authentication/Login";
import ForgotPassword from "./screens/Authentication/ForgotPassword";
import Profile from "./screens/Account/Profile";
import Orders from "./screens/Account/Orders";
import Addresses from "./screens/Account/Addresses";
import ChangePassword from "./screens/Account/ChangePassword";

const ProtectedRoutes = () => {
  const { isLoggedIn } = useContext(AppContext);

  return isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to={`/login?redirectUrl=${window.location.href}`} />
  );
};

const AuthRoutes = () => {
  const { isLoggedIn } = useContext(AppContext);

  return isLoggedIn ? <Navigate to="/" /> : <Outlet />;
};

const App = () => {
  const theme = useMemo(
    () => ({
      colors: {
        primaryColor: "#767676",
        secondaryColor: "#008a7d",
        tertiaryColor: "#007569",
      },
    }),
    []
  );

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <AppProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route element={<ProtectedRoutes />}>
              <Route path={"/profile"} element={<Profile />} />
              <Route path={"/orders"} element={<Orders />} />
              <Route path={"/addresses"} element={<Addresses />} />
              <Route path={"/change-password"} element={<ChangePassword />} />
            </Route>
            <Route element={<AuthRoutes />}>
              <Route path={"/register"} element={<Register />} />
              <Route path={"/login"} element={<Login />} />
              <Route path={"/forgot-password"} element={<ForgotPassword />} />
            </Route>
            <Route path={"/products"} element={<Products />} />
            <Route path={"/farm"} element={<Farm />} />
            <Route path={"/process"} element={<Process />} />
            <Route path={"/about"} element={<About />} />
            <Route path={"/contact"} element={<Contact />} />
            <Route path={"/privacy-policy"} element={<PrivacyPolicy />} />
            <Route path={"/disclaimers"} element={<Disclaimers />} />
            <Route
              path={"/terms-and-conditions"}
              element={<TermsAndConditions />}
            />
            <Route path={"/refund-policy"} element={<RefundPolicy />} />
            <Route path={"*"} element={<PageNotFound />} />
          </Routes>
        </AppProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;
